const AlertIconHome = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2496_14079)" />
      <path
        d="M20.9365 50.0001V48.1383H22.7975V44.3311H47.2065V48.1162H49.0896V50.0001H20.9365Z"
        fill="white"
      />
      <path d="M18.9971 33.049H22.7898V34.9254H18.9971V33.049Z" fill="white" />
      <path
        d="M24.9958 42.4075C25.0727 41.7051 25.1463 41.0228 25.2222 40.3411C25.3788 38.9344 25.5372 37.528 25.6941 36.1214C25.8536 34.6942 26.0129 33.2668 26.1712 31.8394C26.3055 30.6292 26.4308 29.4179 26.5798 28.2095C26.6002 28.0445 26.6971 27.8498 26.8221 27.7431C27.9859 26.7503 29.3764 26.2421 30.8473 25.9308C32.7463 25.5289 34.6685 25.4741 36.5997 25.592C38.1759 25.6882 39.7198 25.9394 41.1917 26.5397C41.9389 26.8445 42.6363 27.2346 43.2432 27.7706C43.336 27.8524 43.4275 27.9831 43.4411 28.1C43.6633 30.0438 43.8701 31.9895 44.086 33.934C44.3042 35.8994 44.5293 37.8637 44.7506 39.8287C44.8391 40.6148 44.9263 41.4009 45.0121 42.1872C45.0197 42.2568 45.0131 42.3281 45.0131 42.4143H35.9759C35.9685 42.3411 35.9542 42.2625 35.9538 42.1837C35.9517 41.6626 35.962 41.1413 35.9477 40.6205C35.9426 40.4322 36.0154 40.355 36.1772 40.2779C37.3999 39.6955 38.0181 38.4719 37.7639 37.1635C37.5294 35.956 36.4746 35.0415 35.1917 34.9334C33.9059 34.8249 32.6616 35.7172 32.3091 37.0004C31.9512 38.3034 32.5552 39.6599 33.783 40.238C34.0291 40.3538 34.0854 40.486 34.0783 40.73C34.0625 41.2811 34.0734 41.8327 34.0734 42.4071H24.9956L24.9958 42.4075Z"
        fill="white"
      />
      <path d="M34.0818 21.7624V18H35.9292V21.7624H34.0818Z" fill="white" />
      <path d="M47.2288 34.9029V33.0659H51.003V34.9029H47.2288Z" fill="white" />
      <path
        d="M26.9934 24.6891C26.5739 25.1086 26.1413 25.541 25.7306 25.9515C24.8816 25.1028 24.0074 24.2288 23.157 23.3788C23.5558 22.9796 23.9938 22.5414 24.419 22.1158C25.2606 22.9571 26.1356 23.8317 26.9934 24.6893V24.6891Z"
        fill="white"
      />
      <path
        d="M45.6478 22.1233C46.0386 22.5147 46.471 22.9475 46.8825 23.3596C46.0239 24.2139 45.144 25.0893 44.2776 25.9513C43.8881 25.5605 43.4568 25.1277 43.0493 24.7189C43.9054 23.8637 44.7836 22.9864 45.6476 22.1233H45.6478Z"
        fill="white"
      />
      <path
        d="M35.0285 36.8034C35.5444 36.8097 35.9502 37.2221 35.95 37.74C35.9498 38.2701 35.5296 38.6834 34.9972 38.6769C34.4703 38.6705 34.0634 38.2426 34.0762 37.7085C34.0884 37.1963 34.5087 36.7969 35.0287 36.8032L35.0285 36.8034Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2496_14079"
          x1="-1.56654e-06"
          y1="4.96155"
          x2="70"
          y2="66.9615"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5A100" />
          <stop offset="1" stop-color="#F14B12" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AlertIconHome
